const ACTION = {
  SET_ADMIN: 'setAdmin',
};

export default ACTION;
